<ng-container [ngSwitch]="level">
    <h1 *ngSwitchCase="1" [id]="id" class="group flex items-center scroll-mt-24 {{ sizeClasses }} {{ className }}">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
        <a [href]="'#' + id" class="ml-2 opacity-0 group-hover:opacity-100 transition-opacity"> 🔗 </a>
    </h1>

    <h2 *ngSwitchCase="2" [id]="id" class="group flex items-center scroll-mt-24 {{ sizeClasses }} {{ className }}">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
        <a [href]="'#' + id" class="ml-2 opacity-0 group-hover:opacity-100 transition-opacity"> 🔗 </a>
    </h2>

    <h3 *ngSwitchCase="3" [id]="id" class="group flex items-center scroll-mt-24 {{ sizeClasses }} {{ className }}">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
        <a [href]="'#' + id" class="ml-2 opacity-0 group-hover:opacity-100 transition-opacity"> 🔗 </a>
    </h3>

    <h4 *ngSwitchCase="4" [id]="id" class="group flex items-center scroll-mt-24 {{ sizeClasses }} {{ className }}">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
        <a [href]="'#' + id" class="ml-2 opacity-0 group-hover:opacity-100 transition-opacity"> 🔗 </a>
    </h4>

    <!-- fallback if someone passes an unsupported level -->
    <h1 *ngSwitchDefault [id]="id" class="group flex items-center scroll-mt-24 {{ sizeClasses }} {{ className }}">
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    </h1>
</ng-container>

<ng-template #content>
    <ng-content></ng-content>
</ng-template>
